import React, { useEffect } from "react";
import WOW from "wowjs";
import { Link } from "react-router-dom";

function ServiceOne({ dataService }) {
  useEffect(() => {
    const wow = new WOW.WOW({
      live: false, // This disables continuous scanning for new elements
    });
    wow.init();
  }, []);

  return (
    <div>
      <div>
        <div className="tmp-services-area services-style--1 background-image-services bg_image tmp-section-gap">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-head">
                  <div className="section-sub-title center-title">
                    <img
                      alt="Business_Consulting_services"
                      src="assets/images/services/section-custom-menubar.png "
                    />
                    <span>{dataService?.title}</span>
                  </div>
                  <h2 className="title split-collab">
                    {dataService?.subTitle}
                  </h2>
                </div>
              </div>
            </div>

            <div className="row g-5">
              {dataService?.items.map((item) => {
                return (
                  <div
                    key={item.id}
                    className="col-lg-3 col-md-4 col-sm-6 col-12 wow fadeInUp"
                    data-wow-duration=".8s"
                    data-wow-delay={`.${item.delay}s`}
                  >
                    <div className="service-inner financial-service-inner agency-service feature-service">
                      <div className="icon">
                        <img src={item?.icon} alt={item?.title} />
                      </div>
                      <div className="content">
                        <h2 className="title">{item?.title}</h2>
                        <p className="description">{item?.desc}</p>
                        <div className="three--dot">
                          <div className="dot dot-one"></div>
                          <div className="dot dot-two"></div>
                          <div className="dot dot-two"></div>
                        </div>
                      </div>

                      <Link to={`/detail_departement_${item.id}`}>
                        <button className="btn-simple">
                          <strong>Voir +</strong>
                        </button>
                      </Link>

                      {/* <Link to={`/detail_departement_${item.id}`} className="over_link"></Link> */}
                    </div>
                  </div>
                );
              })}
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="services-bottom">
                  <div className="services-bottom-inner">
                    <p className="description">{dataService?.description}</p>
                    <p className="description">
                      {dataService?.btnDesc}
                      <Link to={dataService?.btnLink}>
                        <button className="btn-simple">
                          {dataService?.btnName}
                        </button>
                      </Link>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ServiceOne;
